import { notificationActionType } from "@/react/components/Notifications/NotificationsList/List/Actions/ActionContent";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { Notification } from "@/react/types/Notification";
import { GroupUserImage } from "../../GroupUserImage";
import { Item } from "../../Item";
import { Actions } from "../../Item/Actions";
import { TimeStamp } from "../../TimeStamp";
import { UserImageWithIcon } from "../../UserImageWithIcon";

export const DefaultNotificationContent = ({
  notification,
}: {
  notification: Notification;
}) => (
  <div
    className={classNames(
      "flex items-center",
      notificationActionType(notification),
    )}
  >
    {notification.second_actor_name ? (
      <GroupUserImage notification={notification} />
    ) : (
      <UserImageWithIcon
        src={notification.actor_image || ""}
        name={notification.actor_name}
        action={notification.action}
        size="9"
      />
    )}
    <div
      className="flex w-full flex-col items-start space-y-1"
      data-testid="notification-details"
    >
      <Item notification={notification} />
      <TimeStamp createdAt={notification.created_at} />
    </div>
    <div>
      {!notification.read_at ? (
        <div className="flex h-6 w-6 items-center justify-center group-hover:hidden">
          <span className="bg-messaging-info-blue inline-block h-2 w-2 rounded-full group-hover:hidden" />
        </div>
      ) : (
        <div className="flex h-6 w-6 group-hover:hidden" />
      )}
      <Actions notification={notification} />
    </div>
  </div>
);
